import moment from 'moment';
import { BaseDataBind } from './base';

export class DatetimeDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-datetime';
    public selector = '[data-bind-datetime]';
    public eventNames = ['input'];

    protected setElementValue(element: Element, value: any)
    {
        let utc = moment(value).utc();
        let local = utc.local();

        let result = local.format('YYYY-MM-DDThh:mm');
        
        (element as HTMLInputElement).value = result;
    }

    protected getElementValue(element: Element): any
    {
        let value = (element as HTMLInputElement).value;

        let local = moment(value);
        local.utc();

        return local.toISOString();
    }
}